export default {

	schedule1Development: {
		yes: 'Is a "Schedule 1" development',
		no: 'Is not a "Schedule 1" development',
		help: `<p>Development classified as ‘Schedule 1’ development includes all large-scale development, such as power stations, oil refineries, major infrastructure hubs and infrastructure. EIA is compulsory for these projects.</p>`,
	},
	isWithinSensitiveArea: {
		yes: 'Is within a sensitive area',
		no: 'Is not within a sensitive area',
		help: `<p>This is defined in the Town and Country Planning (EIA) Regulations 2017 (as amended)1 to be any of the following:</p>
			<ol>
				<li>Sites of Special Scientific Interest;</li>
				<li>National Park;</li>
				<li>the Broads;</li>
				<li>World Heritage Site;</li>
				<li>Scheduled Monument;</li>
				<li>Area of Outstanding Natural Beauty;</li>
				<li>National Networks Site.</li>
			</ol>
			<p><a href="https://www.legislation.gov.uk/uksi/2017/571/regulation/2/made" target="_blank">The Town and Country Planning (Environmental Impact Assessment) Regulations 2017</a></p>
			<p><a href="https://www.legislation.gov.uk/uksi/2018/695/contents/made" target="_blank">The Town and Country Planning and Infrastructure Planning (Environmental Impact Assessment) (Amendment) Regulations 2018</a></p>
		<p>`,
	},

	/*exceedsSchedule1Thresholds: {
		yes: 'Does exceed "Schedule 1" thresholds',
		no: 'Does not exceed "Schedule 1" thresholds',
		help: 'Copy to be added',
	},*/
	exceedsSchedule2Thresholds: {
		yes: 'Does exceed "Schedule 2" thresholds',
		no: 'Does not exceed "Schedule 2" thresholds',
		help: `<p>Schedule 2 of the EIA Regulations 2017 (as amended) sets out thresholds for determining if the need for consideration of EIA is required. Depending on the type of proposed land use, this can relate to site area, quantum of development, output or other specific criteria.</p>`,
	},
	exceedsGovernmentEIAThresholds: {
		yes: 'Does exceed Government indicative EIA screening thresholds',
		no: 'Does not exceed Government indicative EIA screening thresholds',
		help: `<p>The Government’s Planning Practice Guidance (PPG) sets out that only a small proportion of Schedule 2 development will require an EIA.
In order to help the deciding authority with their judgements alongside the general criteria in Schedule 3 of the EIA Regulations 2017 (as amended), the PPG includes a table setting out ‘indicative EIA screening thresholds and criteria’ to determine whether a project is likely to have significant environmental effects.
</p>
<p><a href="https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/630689/eia-thresholds-table.pdf" target="_blank">PPG Thresholds Table</a></p>`,
	},
	significantEffects: {
		yes: 'May have likely significant environmental effects',
		no: 'May not have likely significant environmental effects',
		help: `<p>Schedule 33 of the EIA Regulations 2017 (as amended) defines criteria for considering whether a development project is likely to have a significant effect on the environment. These are defined by virtue of factors such as size, nature or location.</p>
		<p><a href="https://www.legislation.gov.uk/uksi/2017/571/schedule/3/made" target="_blank">The Town and Country Planning (Environmental Impact Assessment) Regulations 2017</a></p>`,
	},

};
